// @ts-nocheck
import {Button} from "@mui/material";
import {styled} from '@mui/material/styles';

export const BotonVerde = styled(Button)(({theme})  => ({
    backgroundColor: theme.palette.success.main,
    color:'#ffffff',
    margin:'0 5px',
    '&:hover': {
        backgroundColor: theme.palette.success.dark,
    },
}));